export default __webpack_public_path__ + "static/media/icon_triangle_up.2c554f82.svg";